__turbopack_context__.v({
  "caret": "sIswFa_caret",
  "headerContainer": "sIswFa_headerContainer",
  "openingHoursContainer": "sIswFa_openingHoursContainer",
  "openingHoursGroups": "sIswFa_openingHoursGroups",
  "outletOpeningHour": "sIswFa_outletOpeningHour",
  "outletStateClosed": "sIswFa_outletStateClosed",
  "outletStatus": "sIswFa_outletStatus",
  "outletStatusContainer": "sIswFa_outletStatusContainer",
  "outletStatusOpened": "sIswFa_outletStatusOpened",
  "selectedOpeningHourOrderFormat": "sIswFa_selectedOpeningHourOrderFormat",
});
